import { setConfig } from '../../configs/config';
import logging from '../logging';

const getDataLayerKey = () => {
  let dataLayerKey = {};
  window.gapi.client.sheets.spreadsheets.values
    .batchGet({
      spreadsheetId: '1v5AbnxEJtXLUiWhRLI2cEzJcp7lVrQLXVS5020R9h1I',
      ranges: [
        "'NPM CD Tests (do not alter)'!B2:C",
        "'NPM CD Tests (do not alter)'!E2:F",
      ],
      majorDimension: 'ROWS',
    })
    .then(
      (response: { result: { valueRanges: any[] } }) => {
        const dimensionRange = response.result.valueRanges[0];
        const metricRange = response.result.valueRanges[1];
        if (dimensionRange.values.length > 0) {
          logging.info(
            'Loading Google Spreadsheet - Custom Dimension Name, Key:'
          );
          dimensionRange.values.forEach((value: any, i: string | number) => {
            const row = dimensionRange.values[i];
            if (row[0] !== undefined && row[1] !== undefined) {
              dataLayerKey = {
                ...dataLayerKey,
                [row[0]]: row[1],
              };
            }
          });
        }
        if (metricRange.values.length > 0) {
          logging.info('Loading Google Spreadsheet - Custom Metric Name, Key:');
          metricRange.values.forEach((value: any, i: string | number) => {
            const row = metricRange.values[i];
            if (row[0] !== undefined && row[1] !== undefined) {
              dataLayerKey = {
                ...dataLayerKey,
                [row[0]]: row[1],
              };
            }
          });
        }
        setConfig({ dataLayerKey });
      },
      (response: { result: { error: { message: any } } }) => {
        logging.error(`Error: ${response.result.error.message}`);
      }
    );
};

/**
 *  Called when the signed in status changes, to update the UI
 *  appropriately. After a sign-in, the API is called.
 */
const updateSigninStatus = (isSignedIn: any) => {
  if (isSignedIn) {
    logging.info('Islogged');
    getDataLayerKey();
  } else {
    logging.info('isNotLogged');
    window.gapi.auth2.getAuthInstance().signIn();
  }
};

/**
 * Initialiate Google Authentication PO
 */
const initClient = () => {
  const GSHEET_CONFIG = JSON.parse(window.sessionStorage.qbeGoogleAuth);
  window.gapi.client
    .init({
      apiKey: GSHEET_CONFIG.API_KEY,
      clientId: GSHEET_CONFIG.CLIENT_ID,
      discoveryDocs: GSHEET_CONFIG.DISCOVERY_DOCS,
      scope: GSHEET_CONFIG.SCOPES,
    })
    .then(
      () => {
        // Listen for sign-in state changes.
        window.gapi.auth2
          .getAuthInstance()
          .isSignedIn.listen(updateSigninStatus);

        // Handle the initial sign-in state.
        updateSigninStatus(
          window.gapi.auth2.getAuthInstance().isSignedIn.get()
        );
      },
      (error: any) => {
        logging.info(JSON.stringify(error, null, 2));
      }
    );
};

/**
 * Enable Google Authentication pop up.
 */
const handleClientLoad = () => {
  window.gapi.load('client:auth2', initClient);
};

/**
 * Loading Google Library API
 */
const onLoadAPI = () => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://apis.google.com/js/api.js';
  script.async = true;
  document.getElementsByTagName('head')[0].appendChild(script);

  window.onload = () => {
    if (window?.gapi?.load) handleClientLoad();
  };
};

const dimensionMetricValidation = () => {
  if (!window.sessionStorage.getItem('qbeGoogleAuth')) return;
  onLoadAPI();
};

export default dimensionMetricValidation;
